import client from "@/api";

export const listCandidateProfiles = async (params = {}) => {
  return await client.get("/candidate-profiles", { params });
};

export const getCandidateProfile = async (candidateId) => {
  return await client.get(`/candidate-profiles/${candidateId}`);
};

export const saveCandidateProfile = async (candidateId, updates) => {
  return await client.put(`/candidate-profiles/${candidateId}`, updates);
};
